import {doc} from '../../docs.js';
import {uuid} from 'uuidv4';


doc(
    "gl.sdfCopy",
    {
        "sdf": "",
        offset: ""
    },
    "Takes an SDF and outputs an offsetted copy (SDF Manager will efficiently output it)",
    () => 1,
    {
        isHot: true,
        inlets: 2,
        altName: "sdf.copy"
    });

export const gl_sdf_copy = (object, offset) => {
    let id = uuid();
    return ([sdf]) => {
        let _off = offset();
        if (!sdf || !sdf.id) {
            return undefined;
        }
        return {
            id: id,
            copyId: sdf.id,
            offset: _off
        };
    };
};

doc(
    "gl.sdfMultiCopies",
    {
        "sdf": "",
        count: "",
        offset: ""
    },
    "Takes an SDF and outputs an offsetted copy (SDF Manager will efficiently output it)",
    () => 1,
    {
        isHot: true,
        inlets: 3,
        altName: "sdf.multiCopies"
    });

export const gl_sdf_multi_copies  = (object, count, offset) => {
    let id = uuid();
    let copies = undefined;
    return ([sdf]) => {
        let _off = offset();
        if (!_off) {
            return;
        }
        if (!sdf || !sdf.id) {
            return undefined;
        }

        if (!copies || copies.length < count()) {
            copies = [];
            for (let i=copies.length; i <  count(); i++) {
                copies.push(gl_sdf_copy(
                    object, () => [offset()[0]*(i+1),
                                   offset()[1]*(i+1),
                                   offset()[2]*(i+1)]));
            }
        }

        let sdfs = copies.map(
            copy => copy([sdf]));

        return [sdfs];
        /*
        sdfs.forEach(
            sdf =>
            object.sendMessage(
                object.outputByNumber(0),
                sdf));
                */
    };
};

doc(
    "gl.sdfCubeLayout",
    {
        "sdf": "",
        count: "",
        offset: ""
    },
    "Takes an SDF and creates copies of it in a cube formantion",
    () => 1,
    {
        altName: "sdf.cubeLayout",
        isHot: true,
        inlets: 3
    });

export const gl_sdf_cube_layout = (object, size, offset) => {
    let id = uuid();
    let copies = undefined;
    let storedOffsets = [];
    return ([sdf]) => {
        let _off = offset();
        let _size = size();
        if (!_off) {
            return;
        }
        if (!sdf || !sdf.id) {
            return undefined;
        }

        if (!copies) {
            copies = [];
        }
        let counter=0;
        let xOffsets = [];
        let test = [];
        for (let i=0; i < _size; i++) {
            let yOffsets = [];
            for (let j=0; j < _size; j++) {
                let zOffsets = [];
                for (let k=0; k < _size; k++) {
                    if (i===0 && j===0 && k===0) {
                        // we can skip this part of the cube since the initial copy gets that
                        zOffsets.push(undefined);
                        continue;
                    }
                    
                    let currentOffset = [_off*i, _off*j, -_off*k];
                    zOffsets.push(currentOffset);
                    test[counter] = () => storedOffsets[j][i][k];
                    if (!copies[counter]) {
                        copies[counter] = (gl_sdf_copy(
                            object, () => storedOffsets[j][i][k]));
                    }
                    counter++;
                }
                yOffsets.push(zOffsets);
            }
            xOffsets.push(yOffsets);
        }
        storedOffsets = xOffsets;

        let sdfs = copies.map(
            copy => copy([sdf]));

        let y =[[sdf, ...sdfs]];
        return y;
    };
};



